export default "/images/vendor/flag-icon-css/flags/4x3/pl.svg?2b5541c54505328dbc1b264a72369d23";